import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { onload } from 'redux-load-api';
import Helmet from 'react-helmet';
import cn from 'classnames';
import { Alert, Button } from 'react-bootstrap';
import Header from '../components/Header';
import Loader from '../components/common/Loader';
import Info from '../components/Info';
import Notifs from '../components/Notifs';
import UserSnap from '../components/UserSnap';
import styles from './App.css';

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: null };
  }

  componentDidCatch(error, info) {
    console.error(error);
    console.log(info);
    return { hasError: true, errorMessage: error.toString() };
  }

  dismissError = () => this.setState({ hasError: false, errorMessage: null });

  render() {
    return <App {...this.props} {...this.state} dismissError={this.dismissError} />;
  }
}

export function App(props) {
  const { info, loading, children, hasError, errorMessage } = props;

  return (
    <div className={styles.appContainer}>
      <Helmet title="ePRco Gateway" />
      <Header />
      <UserSnap />

      <div className="app-content">
        <div className={cn('container-fluid', 'page-container')}>
          {info.message && (
            <div className="container">
              <Info className="info" />
            </div>
          )}
          {loading ? <Loader /> : null}
          {hasError ? (
            <Alert
              bsStyle="danger"
              onDismiss={this.dismissError}
              style={{ width: 500, margin: 'auto' }}
            >
              <h4>The application has experienced an error</h4>
              {errorMessage}
              <p>You may need to refresh the application.</p>
              <Button bsStyle="danger" onClick={() => document.location.reload()}>
                Take this action
              </Button>
              <span> or </span>
              <Button onClick={this.dismissError}>Dismiss</Button>
            </Alert>
          ) : (
            children
          )}
          <div className="container">
            <Notifs className="notifications" namespace="global" />
          </div>
        </div>
      </div>
    </div>
  );
}

App.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.object.isRequired,
  info: PropTypes.object.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  dismissError: PropTypes.func.isRequired,
};

App.contextTypes = {
  store: PropTypes.object.isRequired,
};

App.defaultProps = {
  loading: false,
  hasError: false,
  errorMessage: null,
};

export default onload(() => {})(
  connect((state) => ({
    info: state.info,
    notifs: state.notifs,
    loading: state.page.loading,
  }))(AppErrorBoundary),
);



// WEBPACK FOOTER //
// ./src/containers/App.js